import { ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ItemHistoryDetailLine } from "./ItemHistoryDetailLine";
import type { ItemHistoryTextLine } from "./itemHistoryRows";

/**
 * A long text edit among other changes: the field's name, with its word diff
 * behind a toggle that starts closed.
 * @param line - The text field's old and new versions
 */
export const ItemHistoryTextDetail = ({
  line,
}: {
  line: ItemHistoryTextLine;
}) => (
  <Collapsible>
    <CollapsibleTrigger className="group -mx-1.5 grid w-[calc(100%+0.75rem)] grid-cols-[14px_minmax(0,1fr)_12px] items-baseline gap-x-2 rounded-sm bg-warning/10 px-1.5 text-left text-sm leading-6 hover:bg-warning/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      <span className="text-center text-warning-foreground">~</span>
      <span>
        <span className="font-semibold">{line.label}</span>
        <span className="text-muted-foreground"> · edited</span>
      </span>
      <ChevronDown
        aria-hidden
        className="h-3 w-3 self-center text-muted-foreground motion-safe:transition-transform group-data-[state=open]:rotate-180"
      />
    </CollapsibleTrigger>
    {/* Layout lives on an inner div: a display utility on the content itself
        would override the hidden attribute Radix sets when closed. */}
    <CollapsibleContent>
      <div className="max-h-40 overflow-y-auto py-1 pl-[22px] pr-1">
        <ItemHistoryDetailLine line={line} />
      </div>
    </CollapsibleContent>
  </Collapsible>
);
